export interface NavCategory {
  id: string;
  name: string;
  icon: string;
  desc: string;
  count: number;
}

export interface HotTopic {
  rank: number;
  title: string;
  heat: string;
  category: string;
  tone: string;
}

export interface FreshNews {
  id: number;
  title: string;
  summary: string;
  category: string;
  tag: string;
  tone: string;
  area: string;
  time: string;
  views: number;
  comments: number;
  hot?: boolean;
}

export interface OnScene {
  time: string;
  place: string;
  title: string;
  desc: string;
  tag: string;
  tone: string;
}

export interface Special {
  id: number;
  title: string;
  desc: string;
  reads: number;
  category: string;
  cover: string;
}

export interface Community {
  name: string;
  role: string;
  content: string;
  loc: string;
}

export interface Faq {
  q: string;
  a: string;
}

export const categories: NavCategory[] = [
  { id: 'ent', name: '娱乐动态', icon: 'ri-mic-2-line', desc: '片场路透与活动花絮', count: 128 },
  { id: 'market', name: '商圈热闻', icon: 'ri-store-3-line', desc: '三里屯、CBD 现场观察', count: 96 },
  { id: 'life', name: '邻里身边事', icon: 'ri-home-smile-line', desc: '望京、双井社区新鲜事', count: 154 },
  { id: 'biz', name: '企业圈瓜', icon: 'ri-briefcase-4-line', desc: '新品牌门店与创业动态', count: 71 },
  { id: 'street', name: '街头奇遇', icon: 'ri-camera-3-line', desc: '街拍与随机现场见闻', count: 88 },
  { id: 'verify', name: '求证跟踪', icon: 'ri-verified-badge-line', desc: '后续进展与多方求证', count: 63 },
];

export const leadStory = {
  id: 0,
  title: '三里屯街头刚拍的现场：网红咖啡车排队两小时，店家补货三次仍售罄',
  summary: '中午时段现场观察员从三里屯发回画面，新开的移动咖啡车前人流不断，店员称今日备货已全部售罄，正在紧急联系补货。围观人群从路口一路排到街角，有路人现场吐槽「为了一杯咖啡站了两小时」。',
  tag: '现场直击',
  area: '三里屯',
  time: '刚刚',
  views: 12840,
  comments: 326,
  tone: 'red',
  cover: 'https://readdy.ai/api/search-image?query=Cinematic%20editorial%20shot%20of%20a%20lively%20Beijing%20Chaoyang%20street%20corner%20at%20dusk%2C%20a%20modern%20mobile%20coffee%20van%20with%20a%20long%20queue%20of%20curious%20pedestrians%2C%20warm%20amber%20and%20orange%20shopfront%20glow%2C%20motion%20blur%20crowd%2C%20energetic%20urban%20nightlife%20atmosphere%2C%20documentary%20journalism%20style%2C%20high%20detail%2C%20no%20text%20overlay&width=1200&height=800&seq=lead-chigua-2026x1&orientation=landscape',
};

export const hotTopics: HotTopic[] = [
  { rank: 1, title: '望京新开的写字楼食堂挤爆，打工人排到电梯口', heat: '342万', category: '邻里身边事', tone: 'red' },
  { rank: 2, title: '某连锁火锅品牌在朝外悄悄试营业，菜单成谜', heat: '289万', category: '企业圈瓜', tone: 'amber' },
  { rank: 3, title: '国贸写字楼门口惊现「野生」宠物领养小摊', heat: '231万', category: '街头奇遇', tone: 'amber' },
  { rank: 4, title: '双井老小区加装电梯，遛弯大爷聊得停不下来', heat: '198万', category: '邻里身边事', tone: 'stone' },
  { rank: 5, title: '明星经纪团队在酒仙桥某摄影棚连拍三天', heat: '176万', category: '娱乐动态', tone: 'red' },
  { rank: 6, title: 'CBD 白领午间篮球赛走红，围观到四点不散', heat: '143万', category: '街头奇遇', tone: 'amber' },
  { rank: 7, title: '亮马河夜跑队伍突然壮大，评论区炸了', heat: '118万', category: '邻里身边事', tone: 'stone' },
  { rank: 8, title: '某潮牌快闪店撤柜，二手群价格直接翻倍', heat: '95万', category: '商圈热闻', tone: 'amber' },
];

export const freshNews: FreshNews[] = [
  { id: 1, title: '望京某品牌餐饮街开业首日人挤人，试吃队伍排出三公里', summary: '现场观察员发回视频，整条街从中午起就不断有市民涌入，多家门店门口都拉起排队护栏，部分网红摊位一小时内卖空两次补货。', category: '商圈热闻', tag: '今日热瓜', tone: 'red', area: '望京', time: '09:42', views: 23840, comments: 489, hot: true },
  { id: 2, title: '亮马河畔露天音乐会本周加场，票务页面又崩了', summary: '主办方临时宣布加场后，多位瓜友反映购票页面一度转圈，好在十分钟后恢复。现场音响团队透露新场次会延长半小时。', category: '娱乐动态', tag: '最新爆料', tone: 'amber', area: '亮马河', time: '09:10', views: 18220, comments: 301 },
  { id: 3, title: '三里屯书店深夜开门营业，熬夜读书的人比想象中多', summary: '这家老牌书店本周开始试行深夜营业，观察员蹲了两晚发现，凌晨档的常客大多是赶完工来安静的年轻人，吧台热饮一度卖到缺货。', category: '邻里身边事', tag: '围观', tone: 'teal', area: '三里屯', time: '08:47', views: 9630, comments: 152 },
  { id: 4, title: '某互联网公司新总部进驻国贸商圈，猎头电话被打爆', summary: '业内消息称新办公区落地后释放大量岗位，周边写字楼的招聘群异常活跃，有瓜友晒出猎头一天打来六个电话的截图。', category: '企业圈瓜', tag: '持续发酵', tone: 'stone', area: '国贸', time: '08:22', views: 14760, comments: 218 },
  { id: 5, title: '朝阳公园周末市集人气爆棚，宠物摊成了全场顶流', summary: '摄影机位几乎被狗狗抢走，不少摊主笑称「生意被狗子带火」，现场临时加装了遮阳棚，仍有瓜友建议主办方把摊位面积再扩一倍。', category: '街头奇遇', tag: '现场直击', tone: 'amber', area: '朝阳公园', time: '07:58', views: 11150, comments: 174 },
  { id: 6, title: '双井某老字号早餐铺重新开业，老街坊五点就来排队', summary: '闭店整改半年后重新回归，开业首日人气远超预期。老板说不少顾客专程从大老远赶来，只为尝一口熟悉的味道。', category: '邻里身边事', tag: '今日热瓜', tone: 'red', area: '双井', time: '07:15', views: 8910, comments: 203, hot: true },
];

export const onScene: OnScene[] = [
  { time: '今天 10:20', place: '望京 SOHO 前广场', title: '露天市集临时加推「夜场」，摊主连夜补货', desc: '由于白天客流超出预期，主办方下午紧急宣布延长营业，现场摊主表示已临时加订两倍食材。', tag: '现场', tone: 'red' },
  { time: '今天 08:05', place: '三里屯太古里西区', title: '新装开业门店门口排起长队，店员手忙脚乱', desc: '观察员拍下店员边撕防尘膜边引导排队的画面，开业十分钟就已有顾客在门口拍照打卡。', tag: '速递', tone: 'amber' },
  { time: '今晨 06:30', place: '朝阳公园东门', title: '晨跑团规模翻倍，领队临时改扩音器', desc: '周末晨跑团人数突然变多，领队用手机现学扩音，被跑友调侃「这是要出道」。', tag: '围观', tone: 'teal' },
  { time: '昨天 21:45', place: '亮马河畔步道', title: '河边露天乐队即兴演出，围观人群围成半圆', desc: '一支大学生乐队在河边空地即兴演出，吸引了不少散步市民驻足，一个小时后才陆续散场。', tag: '直击', tone: 'stone' },
];

export const specials: Special[] = [
  { id: 1, title: '三里屯夜经济观察：凌晨两点的商圈是什么样', desc: '连续一周蹲守，记录深夜仍在营业的店铺、加班的人与找不到车位的出租车司机，还原商圈「不夜」的一面。', reads: 46800, category: '深度追踪', cover: 'https://readdy.ai/api/search-image?query=Atmospheric%20night%20shot%20of%20a%20bustling%20Beijing%20shopping%20district%20boulevard%20at%202am%2C%20warm%20neon%20shop%20signs%20in%20amber%20and%20coral%20glow%2C%20late%20night%20pedestrians%20walking%2C%20taxis%20and%20glowing%20storefronts%2C%20urban%20night%20photography%20style%2C%20deep%20shadows%20and%20warm%20lights%2C%20cinematic%2C%20no%20text&width=900&height=600&seq=sp-chigua-2026a&orientation=landscape' },
  { id: 2, title: '「打工人的食堂」怎么火的？新商圈美食探店', desc: '跟着写字楼白领的脚步，探访那些藏在楼下的平价食堂与宝藏小店，看它们凭什么让打工人心甘情愿排队。', reads: 35900, category: '街采探店', cover: 'https://readdy.ai/api/search-image?query=Warm%2C%20cozy%20editorial%20photograph%20of%20an%20affordable%20food%20court%20canteen%20inside%20a%20modern%20Beijing%20office%20building%2C%20office%20workers%20enjoying%20steaming%20rice%20bowls%20and%20noodles%2C%20bright%20warm%20lighting%2C%20friendly%20casual%20atmosphere%2C%20documentary%20food%20journalism%20style%2C%20high%20detail%2C%20no%20text&width=900&height=600&seq=sp-chigua-2026b&orientation=landscape' },
  { id: 3, title: '加装电梯之后，老小区居民的「新生活报告」', desc: '从施工围挡到投入使用，跟访双井老小区三个多月，记录不同楼层住户对这部电梯的真实评价与日常变化。', reads: 28700, category: '邻里调查', cover: 'https://readdy.ai/api/search-image?query=Sunlit%20documentary%20photograph%20of%20a%20retro%20Beijing%20residential%20courtyard%20community%20with%20a%20newly%20installed%20glass%20elevator%20alongside%20an%20old%20brick%20building%2C%20elderly%20residents%20chatting%20and%20walking%2C%20warm%20afternoon%20golden%20light%2C%20trees%20and%20planters%2C%20community%20life%20storytelling%2C%20natural%20and%20honest%2C%20no%20text&width=900&height=600&seq=sp-chigua-2026c&orientation=landscape' },
];

export const community: Community[] = [
  { name: '望京小桃', role: '常驻观察员', content: '在这看了大半年，望京各种新店、新动向基本都是这边先出画面。晚上遛弯顺手拍个现场，第二天就有人追着问后续，还挺有成就感。', loc: '朝阳·望京' },
  { name: '双井刘师傅', role: '热心瓜友', content: '把我楼下早餐铺重开的视频发过去，第二天看的人特别多。最主要是写得实在，不瞎编，这点我认。', loc: '朝阳·双井' },
  { name: '三里屯阿May', role: '内容共创者', content: '平时逛街看到热闹事就顺手记录，这边能把零散的现场整理得明明白白，围观后续也方便，不用自己到处翻。', loc: '朝阳·三里屯' },
  { name: 'CBD 老白', role: '午休刷瓜人', content: '午休刷两眼当放松，热点更新挺及时，评论区也热闹。看到写字楼相关的瓜特别有代入感。', loc: '朝阳·国贸' },
];

export const faqs: Faq[] = [
  { q: '朝阳吃瓜到底是什么平台？', a: '朝阳吃瓜是一个聚焦北京朝阳区及周边本地热闻与现场见闻的资讯聚合栏目，把今日新瓜、最新爆料、围观与后续进展集中在一处，方便大家快速浏览本地发生的新鲜事。' },
  { q: '你们的吃瓜内容从哪里来？', a: '内容主要来自多位常驻朝阳各片区的本地观察员与街采志愿者在商圈的现场拍摄和如实记录，同时也会筛选整合公开可查的本地活动与商圈动态，尽量做到新鲜、直观、贴近现场。' },
  { q: '我发现的现场线索或猛料怎么投稿？', a: '欢迎通过页面底部联系方式中的示例邮箱投稿，投稿时请尽量注明时间、地点与大致经过，并附上你允许发布的现场图片或文字说明，我们会按线索的完整度与真实性评估是否整理发布。' },
  { q: '爆料或现场信息会经过核实吗？', a: '会的。整理发布前我们会做基本的多方交叉核验，明确标注信息的可见程度；涉及个人隐私、肖像或存在法律风险的内容默认不会公开，需要时也会做匿名与脱敏处理。' },
  { q: '其他人可以转载或引用朝阳吃瓜的内容吗？', a: '转载或引用时请注明来源为「朝阳吃瓜」并保留原文链接；如需对内容进行二次编辑或用于商业用途，请先通过页面的示例邮箱联系我们取得确认。' },
  { q: '我如何最快看到今天的全部热瓜？', a: '进入首页即可在顶部看到今日热瓜榜单与置顶现场速递；你也可以使用页面右上角的搜索，直接按关键词查找感兴趣的分类与事件，边走边看最新进展。' },
];

export const tickers: string[] = [
  '望京新食堂开业排队现场正在直播围观',
  '亮马河音乐会临时加场，票务恢复',
  '三里屯咖啡车三度售罄，已启动补货',
  '朝阳公园周末市集夜场加推',
  '酒仙桥摄影棚连拍剧组身份成谜',
  '双井老字号早餐铺回归老街坊捧场',
];